// Packages
import { Component } from "react";
import moment from "moment";
// Views
// Styles

import "bootstrap/dist/css/bootstrap.css";

// Services
import { withRouter } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import WarningIcon from "@mui/icons-material/Warning";
import PaidIcon from "@mui/icons-material/Paid";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import { CircularProgress, Paper } from "@material-ui/core";
import CommonMenu from "./CommonMenu";
import CustomSearch from "./CustomSearch";
import userService from "../services/user.service";
import ErrorMessage from "./ErrorMessage";
import DeleteDialog from "../component/schoolAdminPortal/Popups/DeleteDialog";
import { connect } from "react-redux";
import {
  openFailDialog,
  openSuccessPopup,
} from "../Redux/Actions/PopupActions";

class PaymentHistoryTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      schoolId: this.props?.match?.params?.schoolId,
      billingDetailsResponses: [],
      deleteId: "",
      openDeletePop: false,
      pageState: {
        isLoading: false,
        data: [],
        total: 0,
        page: 0,
        pageSize: 10,
      },
      recordNotFound: false,
      searchQuery: "",
      btnText: "",
      successPopup: false,
      msg: "",
      redirectToRow: false,
      currentRowId: "",
      searchedRecord: false,
      userRole: this.props.userRole,
      submitting: false,
    };
  }

  componentDidMount() {
    const payment = document.getElementById("Payments");
    const { pageState, schoolId } = this.state;
    if (payment) {
      payment.classList.add("active");
    }
    this.getAllBillingDetails(schoolId);
    this.setState({ submitting: true });
    this.getBillingDetailsByPage(pageState.page, pageState.pageSize);
  }

  editPaymentApiCall = (data) => {
    const { pageState, searchQuery, searchedRecord } = this.state;
    const amount = data.amount.slice(1);
    const id = data.id;
    const note = data.note;
    const paymentMethod = data.paymentMethod;
    const paymentStatus = "Overdue";
    const schoolId = data.schoolId;
    const uploadFilesInvoiceId = data.uploadFiles.id;
    const validityDate = moment(data.validityDate).format("YYYY-MM-DD");
    userService
      .editPayments(
        amount,
        id,
        note,
        paymentMethod,
        paymentStatus,
        schoolId,
        uploadFilesInvoiceId,
        validityDate
      )
      .then((response) => {
        if (searchedRecord) {
          this.searchPayment(searchQuery, pageState.page, 10);
        } else {
          this.getBillingDetailsByPage(pageState.page, 10);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  editPaymentApiCallPaid = (data) => {
    const { pageState, searchedRecord, searchQuery } = this.state;
    const amount = data.amount.slice(1);
    const id = data.id;
    const note = data.note;
    const paymentMethod = data.paymentMethod;
    const paymentStatus = "Paid";
    const schoolId = data.schoolId;
    const uploadFilesInvoiceId = data.uploadFiles.id;
    const validityDate = moment(data.validityDate).format("YYYY-MM-DD");
    userService
      .editPayments(
        amount,
        id,
        note,
        paymentMethod,
        paymentStatus,
        schoolId,
        uploadFilesInvoiceId,
        validityDate
      )
      .then((response) => {
        if (searchedRecord) {
          this.searchPayment(searchQuery, pageState.page, 10);
        } else {
          this.getBillingDetailsByPage(pageState.page, 10);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  editPaymentApiCallPending(data) {
    const amount = data.amount.slice(1);
    const id = data.id;
    const note = data.note;
    const paymentMethod = data.paymentMethod;
    const paymentStatus = "Pending";
    const schoolId = data.schoolId;
    const uploadFilesInvoiceId = data.uploadFiles.id;
    const validityDate = moment(data.validityDate).format("YYYY-MM-DD");
    userService
      .editPayments(
        amount,
        id,
        note,
        paymentMethod,
        paymentStatus,
        schoolId,
        uploadFilesInvoiceId,
        validityDate
      )
      .then((response) => {
        this.getAllBillingDetails(this.state.schoolId);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  getAllBillingDetails(schoolId) {
    userService
      .getSchoolBillingDetails(schoolId)
      .then((response) => {
        const { data } = response.data;
        const billingDetailsResponses = data.billingDetailsResponses;
        const schoolname = data.billingDetailsResponses[0].schoolName;
        this.setState({ billingDetailsResponses, schoolname });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  getBillingDetailsByPage = (page, size) => {
    const { schoolId, recordNotFound, pageState } = this.state;
    this.setState({
      pageState: { ...pageState, isLoading: true },
    });
    userService
      .getSchoolBillingDetailsByPage(schoolId, page, size)
      .then((res) => {
        const data = res.data.data;
        this.setState({
          pageState: {
            ...pageState,
            data: data.billingDetailsResponses,
            isLoading: false,
            total: data.total,
            page: page,
          },
          submitting: false,
        });
        if (recordNotFound) {
          this.setRecordNotFound();
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          pageState: { ...pageState, isLoading: true },
          submitting: false,
        });
      });
  };

  openInNewTab = (url) => {
    var newWindow = window.open(
      url.uploadFiles.filePath,
      "_blank",
      "noopener,noreferrer"
    );
    if (newWindow) newWindow.opener = null;
  };

  deleteInvoicePop = (data) => {
    this.setState({
      deleteId: data.id,
      openDeletePop: true,
      msg: "Are you sure you want to delete the school Invoice?",
    });
  };

  closeDialog = () => {
    var openDeletePop = false;
    this.setState({ openDeletePop });
  };

  ConfirmcloseDialog = () => {
    this.setState({ openDeletePop: false });
    this.deleteInvoice();
  };

  openDialogRemoved() {
    this.setState({ openRemove: !this.state.openRemove });
  }
  closeDialogRemoved() {
    this.setState({ openRemove: !this.state.openRemove });
  }

  deleteInvoice = () => {
    const { pageState, searchedRecord, deleteId, searchQuery } = this.state;
    const { setSuccessPopupInformation, setFailPopUpInformation } = this.props;
    userService
      .deletePayments(deleteId)
      .then((response) => {
        this.getBillingDetailsByPage(pageState.page, pageState.pageSize);
        const newPageNumber =
          pageState.data.length == 1 && pageState.page > 0
            ? pageState.page - 1
            : pageState.page;
        if (searchedRecord) {
          this.searchPayment(searchQuery, newPageNumber, 10);
        } else {
          this.getBillingDetailsByPage(newPageNumber, pageState.pageSize);
        }
        this.setState({
          openDeletePop: false,
        });
        setSuccessPopupInformation({
          successPopUp: {
            message: "Invoice Removed Successfully.",
            open: true,
          },
        });
      })
      .catch((error) => {
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  setSearchQuery = (value) => {
    this.setState({ searchQuery: value });
  };

  setSearchedRecord = (value) => {
    this.setState({ searchedRecord: value });
  };

  setRecordNotFound = () => {
    this.setState({ recordNotFound: false });
  };

  searchPayment = (query, page, size) => {
    const { schoolId, searchedRecord } = this.state;
    this.setState({
      pageState: { ...this.state.pageState, isLoading: true },
      searchQuery: query,
    });
    if (!searchedRecord) {
      this.setState({ searchedRecord: true });
    }
    userService
      .searchPayment(query, page, size)
      .then((res) => {
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: res.data.data.billingDetailsResponses,
            isLoading: false,
            total: res.data.data.total,
            page: page,
          },
          recordNotFound:
            res.data.data.billingDetailsResponses.length == 0 ? true : false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: [],
            isLoading: false,
            total: 0,
            page: page,
          },
          recordNotFound: true,
        });
      });
  };

  toggleSuccessDialog = () => {
    const { successPopup } = this.state;
    this.setState({ successPopup: !successPopup });
  };

  render() {
    const {
      openDeletePop,
      pageState,
      searchQuery,
      searchedRecord,
      recordNotFound,
      submitting,
      msg,
    } = this.state;

    const menuItemContent = (data) => {
      const arr = [
        {
          id: "1",
          name: "Delete",
          icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
          ApiCall: this.deleteInvoicePop,
        },
        {
          id: "2",
          name:
            data.paymentStatus === "Paid" ? "Mark as overdue" : "Mark as Paid",
          icon:
            data.paymentStatus === "Paid" ? (
              <WarningIcon className="manage-section-iconss" />
            ) : (
              <PaidIcon className="manage-section-iconss" />
            ),
          ApiCall:
            data.paymentStatus === "Paid"
              ? this.editPaymentApiCall
              : this.editPaymentApiCallPaid,
        },
        {
          id: "3",
          name: "Download Invoice",
          icon: <DownloadForOfflineIcon className="manage-section-iconss" />,
          ApiCall: this.openInNewTab,
        },
      ];
      return arr;
    };
    const tableColumns = [
      {
        field: "school.schoolName",
        headerName: "Invoice Id",
        headerAlign: "center",
        headerClassName: "table-header bold",
        width: 200,
        cellClassName: "custom-cell",
        renderCell: (params) => (
          <div className="d-flex-align-cent height-70 w-100">
            <p className="text-width-auto mg-auto">{params.row.invoiceId}</p>
          </div>
        ),
      },
      {
        field: "validityDueDate",
        headerName: "Due Date",
        headerAlign: "center",
        headerClassName: "table-header bold",
        width: 200,
        align: "center",
        cellClassName: "custom-cell",
      },
      {
        field: "paymentMethod",
        headerName: "Payment Method",
        headerAlign: "center",
        headerClassName: "table-header bold",
        align: "center",
        flex: 1,
        minWidth: 200,
        cellClassName: "custom-cell",
      },
      {
        field: "amount",
        headerName: "Amount",
        headerAlign: "center",
        headerClassName: "table-header bold",
        align: "center",
        width: 200,
        cellClassName: "custom-cell",
      },
      {
        field: "status",
        headerName: "Status",
        headerAlign: "center",
        headerClassName: "table-header bold",
        width: 200,
        cellClassName: "custom-cell",
        align: "center",
        renderCell: (params) => (
          <div
            className={
              params.row.paymentStatus == "Paid"
                ? "paymentStatus bg-success-color"
                : "paymentStatus bg-warning-color"
            }
          >
            {params.row.paymentStatus}
          </div>
        ),
      },
      {
        field: "action",
        headerName: "Action",
        headerAlign: "center",
        headerClassName: "table-header bold",
        width: 200,
        cellClassName: "custom-cell",
        align: "center",
        renderCell: (params) => (
          <div>
            <CommonMenu
              menuContent={menuItemContent(params.row)}
              rowData={params.row}
            />
          </div>
        ),
      },
    ];
    return (
      <div>
        <div>
          <div>
            {!submitting && (pageState.data.length > 0 || recordNotFound) && (
              <Paper className="pad-top-20">
                <CustomSearch
                  searchQuery={searchQuery}
                  setSearchQuery={this.setSearchQuery}
                  setSearchedRecord={this.setSearchedRecord}
                  searchedRecord={searchedRecord}
                  getDataByPage={this.getBillingDetailsByPage}
                  pageState={pageState}
                  searchData={this.searchPayment}
                  setRecordNotFound={this.setRecordNotFound}
                />
                <DataGrid
                  rows={pageState.data}
                  rowCount={pageState.total}
                  loading={pageState.isLoading}
                  pagination
                  page={pageState.page}
                  columns={tableColumns}
                  pageSize={pageState.pageSize}
                  rowsPerPageOptions={[10]}
                  paginationMode="server"
                  onPageChange={(newPage) => {
                    if (searchQuery == "") {
                      this.getBillingDetailsByPage(newPage, 10);
                    } else {
                      this.searchPayment(searchQuery, newPage, 10);
                    }
                    this.setState({ ...pageState, page: newPage });
                  }}
                  onPageSizeChange={(newPageSize) =>
                    this.setState({
                      ...pageState,
                      pageSize: newPageSize,
                    })
                  }
                  sx={{
                    color: "black",
                    fontFamily: "Rajdhani-SemiBold",
                    fontSize: "18px",
                    backgroundColor: "white",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                  }}
                  autoHeight
                  disableColumnMenu
                  getRowHeight={() => "auto"}
                  disableSelectionOnClick
                />
              </Paper>
            )}
            {!pageState.data.length > 0 && !submitting && !recordNotFound && (
              <ErrorMessage />
            )}
          </div>

          <div className="clear20"></div>
        </div>
        {submitting && (
          <div className="content-layout-loading-animation">
            <CircularProgress sx={{ fontSize: 10, color: "#002244" }} />
          </div>
        )}

        <DeleteDialog
          open={openDeletePop}
          closeDialog={this.closeDialog}
          deleteRecord={this.deleteInvoice}
          deleteId={null}
          msg={msg}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSuccessPopupInformation: (obj) => openSuccessPopup(dispatch, obj),
    setFailPopUpInformation: (obj) => openFailDialog(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return state;
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PaymentHistoryTable)
);
